export const experience= [
    {
        "id":0,
        "companyName":"Workato Inc.",
        "companyLogo":"workato.webp",
        "jobTitle":"Software Engineer",
        "from":"12/2024",
        "to":"Present",
        "keyProjects": [
            {
                "id": 1,
                "name": "Workato Go",
                "description": "GPT-like chat interface with Google Calendar integration and Homepage",
                "tech": ["React", "TypeScript", "NX Monorepo"]
            },
            {
                "id": 2,
                "name": "Chrome Extension",
                "description": "Manifest V3 extension for seamless enterprise search integration",
                "tech": ["Chrome API", "Manifest V3", "Real-time Sync"]
            },
            {
                "id": 3,
                "name": "AgentX Support App",
                "description": "Intelligent customer support assistant with response suggestions",
                "tech": ["React", "Shadcn/ui", "AI/ML"]
            },
            {
                "id": 4,
                "name": "Organization Chart Builder",
                "description": "Interactive drag-and-drop org chart with hierarchical visualizations",
                "tech": ["React", "Drag & Drop", "Real-time Collaboration"]
            }
        ],
        "description":[
            {
            "id":1,
            "desc":"Built GPT-like chat interface, Organization Chart builder, Google Calendar integration, and Homepage for Workato Go using React and TypeScript."
        },
        {
            "id":2,
            "desc":"Built Chrome extension using Manifest V3 for seamless enterprise search integration directly into browser workflows with real-time data sync."
        },
        {
            "id":3,
            "desc":"Developed AgentX Support App using Shadcn/ui components, enhancing customer support efficiency with intelligent response suggestions."
        },
        {
            "id":4,
            "desc":"Designed and implemented interactive Organization Chart Builder with drag-and-drop functionality, hierarchical visualizations, and real-time collaboration features."
        },
        {
            "id":5,
            "desc":"Led frontend architecture on an NX Monorepo with shared libraries and build caching, cutting average CI/production build times by ~40%."
        },
        {
            "id":6,
            "desc":"Implemented modern UI/UX with Shadcn/ui and Tailwind CSS, ensuring consistent design system across all enterprise products."
        }
    ]
    },
    {
        "id":1,
        "companyName":"DeepConverse, Inc.",
        "companyLogo":"dc.png",
        "jobTitle":"Software Engineer - Frontend",
        "from":"01/2022",
        "to":"11/2024",
        "keyProjects": [
            {
                "id": 1,
                "name": "AI Chatbot Platform",
                "description": "Conversational AI interfaces with real-time WebSocket integration",
                "tech": ["React", "Ant Design", "WebSocket"]
            },
            {
                "id": 2,
                "name": "AI Agent Dashboard",
                "description": "Comprehensive analytics and LLM configuration management system",
                "tech": ["React", "Ant Design", "Real-time Data Viz"]
            },
            {
                "id": 3,
                "name": "Conversation Flow Builder",
                "description": "Drag-and-drop visual AI agent configuration using React Flow",
                "tech": ["React Flow", "Drag & Drop", "Visual Builder"]
            },
            {
                "id": 4,
                "name": "LLM Integration",
                "description": "GPT & Claude API integration with streaming and cost estimation",
                "tech": ["GPT API", "Claude API", "Streaming"]
            }
        ],
        "description":[
            {
            "id":1,
            "desc":"Designed and implemented conversational AI interfaces and chatbot UIs using React.js and Ant Design, enabling seamless human-AI interactions."
        },
        {
            "id":2,
            "desc":"Built comprehensive dashboards with Ant Design components for AI Agent management, conversation analytics, and LLM configuration with real-time data visualization."
        },
        {
            "id":3,
            "desc":"Developed real-time chat interfaces with WebSocket integration for live AI bot conversations, typing indicators, and agent monitoring."
        },
        {
            "id":4,
            "desc":"Implemented LaunchDarkly feature flags for controlled rollout of AI features, A/B testing, and gradual feature releases across user segments."
        },
        {
            "id":5,
            "desc":"Integrated LLM APIs (GPT, Claude) into frontend applications with streaming responses, implementing real-time token counting and cost estimation UI."
        },
        {
            "id":6,
            "desc":"Built drag-and-drop conversation flow builders and visual AI agent configuration panels using React Flow, enabling non-technical users to customize bot behavior."
        },
        {
            "id":7,
            "desc":"Created a reusable Ant Design component library shared across AI products, standardizing UI patterns and speeding delivery of new agent dashboards."
        }
    ]
    },
    {
        "id":2,
        "companyName":"Troniqs Rationale Technologies and Services pvt Ltd.",
        "companyLogo":"trq.png",
        "jobTitle":"Front-End Developer → Senior Full Stack Engineer",
        "from":"05/2019 – 09/2019 · 07/2021 – 12/2021",
        "to":"",
        "description":[
            {
            "id":1,
            "desc":"Two contract engagements: front-end developer (2019), then rehired as senior full stack engineer (2021)."
        },
        {
            "id":2,
            "desc":"Shipped responsive React.js and Vue.js apps from Figma designs with pixel-perfect implementation."
        },
        {
            "id":3,
            "desc":"Collaborated with backend and design on scalable web services, APIs, and usability improvements."
        },
        {
            "id":4,
            "desc":"Mentored junior developers on React, Vue, and Node.js and established team code review practices."
        }
    ]
    },
    {
        "id":3,
        "companyName":"GoldFinch",
        "companyLogo":"goldfinch.png",
        "jobTitle":"Front-End Developer",
        "from":"07/2020",
        "to":"06/2021",
        "description":[
            {
            "id":1,
            "desc":"Transformed UI/UX designs (Adobe XD, Figma) into responsive, performant React.js applications."
        },
        {
            "id":2,
            "desc":"Collaborated with backend teams and designers to enhance user experience and application performance."
        },
        {
            "id":3,
            "desc":"Developed reusable component libraries and design systems for consistent UI across products."
        },
        {
            "id":4,
            "desc":"Mentored junior frontend developers on React best practices and modern development workflows."
        }
    ]
    },
    {
        "id":4,
        "companyName":"Freelancer",
        "companyLogo":"freelancer.png",
        "jobTitle":"Full Stack Developer (Part-time)",
        "from":"10/2019",
        "to":"06/2020",
        "description":[
            {
            "id":1,
            "desc":"Part-time freelance while completing full-time Master's; delivered React/Node solutions for client projects."
        },
        {
            "id":2,
            "desc":"Converted design mockups (Adobe XD, Figma) into responsive web applications using React.js, HTML5, and CSS3."
        },
        {
            "id":3,
            "desc":"Designed and implemented RESTful APIs using Node.js and Express for client applications."
        }
    ]
    },
    {
        "id":6,
        "companyName":"Freelancer",
        "companyLogo":"freelancer.png",
        "jobTitle":"Front-End Developer (Part-time)",
        "from":"05/2018",
        "to":"04/2019",
        "description":[
            {
            "id":1,
            "desc":"Part-time freelance during final year of BE and start of full-time Master's."
        },
        {
            "id":2,
            "desc":"Created WordPress websites using Elementor for clients requiring CMS solutions."
        },
        {
            "id":3,
            "desc":"Implemented pixel-perfect designs with focus on responsive layouts and user experience."
        }
    ]
    }
]
